
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetomumbaiinnovacrystacab() {



    const cardData =
    {
        keyword: 'Pune to Mumbai Innova Crysta Cab',
        heading: 'Meghana Cab : Pune to Mumbai Innova Crysta Cab',
        headingDescription: 'Meghana Cab offers Pune to Mumbai Innova Crysta Cab service, perfect for premium travel with family, corporate teams, or small groups. Our Innova Crysta vehicles are known for their luxurious interiors, powerful performance, spacious seating, and advanced safety features—making them ideal for long-distance travel. Whether it’s an airport transfer, business meeting, or weekend trip to Mumbai, enjoy a smooth ride with experienced chauffeurs, on-time pickups, and ample luggage space. Book your Pune to Mumbai Innova Crysta Cab with Meghana Cab for a first-class intercity travel experience backed by transparent pricing and 24/7 customer support.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

      "topPlaces": [ 
 
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most enduring symbol, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this colossal basalt arch marks the point from which the last British troops left India, making it both a historical and emotional landmark. Located in Apollo Bunder, it serves as a hub for ferry rides to Elephanta Island and provides stunning views at sunrise and sunset. The Indo-Saracenic style architecture and its vibrant surroundings filled with street vendors, photographers, and tourists make it a dynamic cultural hub."
  },
   {
    "title": "Siddhivinayak Temple",
    "description": "One of the richest and most visited temples in Mumbai, Siddhivinayak is dedicated to Lord Ganesha, the remover of obstacles. Originally built in 1801, it features a gold-plated inner sanctum and a unique idol carved from a single black stone, with the trunk curving to the right. The temple draws politicians, Bollywood celebrities, and millions of devotees annually, especially on Tuesdays when the lines stretch for hours. Despite the crowds, the spiritual atmosphere and meticulous organization make it a peaceful yet powerful experience."
  },
  {
    "title": "Marine Drive & Girgaon Chowpatty",
    "description": "Stretching 3.6 kilometers along the Arabian Sea, Marine Drive is Mumbai’s iconic palm-lined promenade shaped like a necklace, earning it the nickname 'Queen’s Necklace.' It’s a favorite spot for joggers, lovers, and tourists who gather to admire the sea view and city skyline, especially at sunset. At the northern end lies Girgaon Chowpatty, a lively beach known for its street food—bhel puri, pav bhaji, gola—and as a venue for the grand Ganesh Visarjan immersions. The entire stretch embodies Mumbai’s coastal spirit and urban pulse."
  },
   {
    "title": "Elephanta Caves",
    "description": "Located 11 km offshore on Elephanta Island, these 5th-to-8th-century rock-cut caves are a UNESCO World Heritage Site showcasing ancient Indian art dedicated primarily to Lord Shiva. The highlight is the massive Trimurti sculpture—depicting the three aspects of Shiva—carved into a single rock face. The island offers not just religious and artistic significance but also scenic views, lush trails, and a tranquil ferry ride from the Gateway of India, making it a full-day cultural and nature getaway from Mumbai's bustle."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A masterpiece of Victorian Gothic Revival architecture fused with Indian design, CST (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of India’s busiest railway stations. Constructed in 1887, the terminus features turrets, pointed arches, domes, stained-glass windows, and intricate carvings of animals and deities. It stands as a testament to colonial-era craftsmanship while functioning as a modern-day transport lifeline for over 3 million daily commuters. Its majestic façade is especially breathtaking when illuminated at night."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in 1431 in honor of the Sufi saint Haji Ali, this Indo-Islamic marble dargah sits on a tiny islet 500 meters off the coast, connected by a narrow causeway that floods during high tide. It is visited by people of all religions and backgrounds, symbolizing Mumbai’s spiritual inclusiveness. With white domes, intricate mirror work, and prayers echoing against sea winds, it offers both a religious and atmospheric experience. The view of the Mumbai skyline from the dargah adds a contemplative beauty to the site."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "Housed in a grand Indo-Saracenic building amidst lush gardens, this museum features over 50,000 artifacts from ancient to modern India. Its galleries cover art, archaeology, armory, numismatics, and decorative arts, including standout collections of miniature paintings, Buddhist sculptures, Mughal weaponry, and European antiques. The museum offers guided tours, audio guides, and children's workshops, making it both educational and engaging for visitors of all ages. Its architectural grandeur and curated exhibits make it one of India’s finest museums."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant shopping and cultural district near the Gateway of India, Colaba Causeway offers a sensory overload of colors, sounds, and flavors. Street stalls sell everything from junk jewelry and antiques to clothing and souvenirs, while iconic cafés like Leopold and Café Mondegar cater to tourists and locals alike. It’s the perfect place to experience Mumbai’s cosmopolitan vibe, blending colonial architecture with contemporary fashion, street food, and bustling life from early morning until late night."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal stretches, offering a blend of natural beauty, local flavors, and a touch of celebrity culture. Frequented by locals for evening walks, kite flying, and beachside yoga, the beach is also known for its chaat stalls, pony rides, and occasional film shoots. It's common to spot Bollywood stars residing nearby. The beach also hosts cultural festivals and public events, making it more than just a leisure destination—it’s a slice of Mumbai’s identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "This 87-square-kilometer green oasis within city limits offers a rare mix of wildlife sanctuary, recreational space, and ancient history. The park houses deer, leopards, monkeys, and over 250 species of birds, along with a toy train, boating lake, and nature trails. The Kanheri Caves within the park—dating from 1st century BCE to 10th century CE—are a group of over 100 Buddhist rock-cut monasteries and prayer halls. The combination of spirituality, wildlife, and open space makes it one of Mumbai’s most unique destinations."
  }
],

   "services": [
    {
      "name": "Innova Crysta Cab Pune to Mumbai",
      "description": "Travel in comfort and style with our Innova Crysta cab service from Pune to Mumbai. This premium 6-seater SUV is ideal for long-distance trips, offering plush interiors, superior ride quality, ample luggage space, and trusted chauffeurs for a smooth highway experience."
    },
    {
      "name": "Book Innova Crysta Pune to Mumbai",
      "description": "Book your Innova Crysta online for a safe and luxurious ride from Pune to Mumbai. Our seamless booking system provides instant confirmation, real-time driver tracking, and flexible options tailored for families, corporate clients, or airport transfers."
    },
    {
      "name": "6-Seater Crysta Pune to Mumbai Trip",
      "description": "Our 6-seater Innova Crysta is perfect for group or family trips from Pune to Mumbai. With captain seats, spacious legroom, rear AC vents, and top-notch suspension, every journey becomes relaxing and enjoyable, even on longer routes."
    },
    {
      "name": "AC Crysta Taxi Pune to Mumbai",
      "description": "Enjoy a cool and relaxed ride in our air-conditioned Innova Crysta taxis. Perfect for Pune to Mumbai travel, especially during summers or long rides, our AC taxis ensure comfort and temperature control throughout your journey."
    },
    {
      "name": "Online Innova Crysta Booking Pune to Mumbai",
      "description": "Reserve your Innova Crysta cab from Pune to Mumbai online within minutes. Choose your pickup time, vehicle preference, and get a transparent fare estimate instantly. Our system offers 24/7 booking support and secure payment options."
    },
    {
      "name": "Luxury SUV Cab Pune to Mumbai",
      "description": "Experience the road like never before in our luxury Innova Crysta SUV cab. Designed for comfort and class, it’s a premium choice for VIPs, executives, or those seeking a refined ride with advanced features, stylish interiors, and smooth suspension."
    },
    {
      "name": "Family Travel Innova Pune to Mumbai",
      "description": "Traveling with family? The Innova Crysta offers a spacious and safe travel solution from Pune to Mumbai. Equipped with seatbelts, child locks, and a roomy interior, it's ideal for kids, elders, and everyone in between."
    },
    {
      "name": "Chauffeur Driven Innova Crysta Cab Pune to Mumbai",
      "description": "Relax with our professional chauffeur-driven Innova Crysta cab. Our drivers are experienced in long-distance travel and customer service, ensuring punctuality, safety, and comfort on your Pune to Mumbai ride."
    },
    {
      "name": "Round Trip Innova Crysta Pune to Mumbai",
      "description": "Planning a return from Mumbai the same or next day? Our round-trip Innova Crysta cab service gives you the same vehicle and driver both ways, with customized wait time and competitive fares for added convenience and value."
    },
    {
      "name": "One Way Crysta Cab Pune to Mumbai",
      "description": "Book a one-way Innova Crysta taxi from Pune to Mumbai without paying for the return. This option is perfect for business meetings, airport drop-offs, or travel plans that don’t include a return on the same day."
    },
    {
      "name": "Comfortable Innova Pune to Mumbai Ride",
      "description": "Comfort is guaranteed in our Innova Crysta cabs from Pune to Mumbai. With reclining seats, spacious interiors, and excellent suspension, passengers can relax and enjoy the ride, even during traffic or longer durations."
    },
    {
      "name": "Business Travel Cab Innova Crysta Pune to Mumbai",
      "description": "Executives prefer the Innova Crysta for its blend of comfort, luxury, and space. Book for meetings, airport pickups, or corporate tours from Pune to Mumbai with GST billing and premium onboard experience."
    },
    {
      "name": "Budget Crysta Cab Hire Pune Mumbai",
      "description": "Enjoy premium travel without the premium price. Our budget-friendly Innova Crysta cab hire service offers competitive rates, clean vehicles, and reliable service for a quality trip that’s easy on your wallet."
    },
    {
      "name": "Group Travel Pune to Mumbai Innova Crysta",
      "description": "Heading to Mumbai with a small group? Our Innova Crysta is the best option for group travel. It comfortably fits 6 passengers with luggage, and is equipped with features to make the trip smooth and social."
    },
    {
      "name": "Safe Travel Crysta Cab Pune to Mumbai",
      "description": "Safety is our priority. All Innova Crysta cabs are regularly sanitized, fitted with safety features like airbags, ABS, seatbelts for all passengers, and driven by verified, trained drivers for secure Pune to Mumbai travel."
    }
  ],
  "tableData": [
    ["Innova Crysta Cab Pune to Mumbai", "Book Innova Crysta Pune to Mumbai"],
    ["6-Seater Crysta Pune to Mumbai Trip", "AC Crysta Taxi Pune to Mumbai"],
    ["Online Innova Crysta Booking Pune to Mumbai", "Luxury SUV Cab Pune to Mumbai"],
    ["Family Travel Innova Pune to Mumbai", "Chauffeur Driven Innova Crysta Cab Pune to Mumbai"],
    ["Round Trip Innova Crysta Pune to Mumbai", "One Way Crysta Cab Pune to Mumbai"],
    ["Comfortable Innova Pune to Mumbai Ride", "Business Travel Cab Innova Crysta Pune to Mumbai"],
    ["Budget Crysta Cab Hire Pune Mumbai", "Group Travel Pune to Mumbai Innova Crysta"],
    ["Safe Travel Crysta Cab Pune to Mumbai", ""]
  ],





"whychoose": [
    {
        "WhyChooseheading": "Premium Innova Crysta Cab from Pune to Mumbai",
        "WhyChoosedescription": "Experience luxury and reliability with our Innova Crysta cab service from Pune to Mumbai. Perfect for families, corporate groups, or travelers seeking a spacious ride, the Crysta offers unmatched comfort, smooth handling, and a premium intercity travel experience."
    },
    {
        "WhyChooseheading": "Spacious 6-7 Seater Configuration with Ample Luggage Room",
        "WhyChoosedescription": "The Innova Crysta is known for its roomy interiors, making it ideal for group travel. With comfortable captain seats or bench seating, and generous luggage space, it's a great fit for airport transfers, long drives, or weekend trips with extra baggage."
    },
    {
        "WhyChooseheading": "Luxury Interiors and Top-Class Comfort Features",
        "WhyChoosedescription": "Travel in style with features like dual-zone AC, reclining seats, plush upholstery, and a silent cabin. The Crysta is designed for a smooth, relaxing journey—even on longer intercity routes like Pune to Mumbai."
    },
    {
        "WhyChooseheading": "Expert, Courteous, and Well-Trained Chauffeurs",
        "WhyChoosedescription": "Our professional drivers are trained in long-distance travel, background-verified, and familiar with the Pune–Mumbai route. They maintain safe driving practices, assist with luggage, and ensure you reach your destination safely and on time."
    },
    {
        "WhyChooseheading": "Transparent All-Inclusive Pricing for Peace of Mind",
        "WhyChoosedescription": "No hidden charges—just clear, competitive pricing. Your fare includes tolls, fuel, taxes, and driver allowance. With the Innova Crysta, you enjoy a premium ride and premium service, all at an honest and affordable rate."
    },
    {
        "WhyChooseheading": "Ideal for Business Travel, Family Trips & Airport Transfers",
        "WhyChoosedescription": "The Innova Crysta offers the perfect balance of luxury and functionality, making it suitable for corporate meetings, client pickups, family vacations, or airport transfers where space and presentation matter."
    },
    {
        "WhyChooseheading": "Flexible One-Way, Round-Trip, and Multi-Stop Options",
        "WhyChoosedescription": "Book as per your schedule—whether it’s a one-way transfer to Mumbai, a round-trip back to Pune, or a multi-stop day plan. We offer full flexibility to accommodate meetings, sightseeing, or stopovers as needed."
    },
    {
        "WhyChooseheading": "24/7 Booking Support and Real-Time Customer Assistance",
        "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, special travel needs, or changes. Book online or by phone anytime and enjoy a hassle-free, responsive customer experience from start to finish."
    }
]



















    }

const faqData = [
    {
        question: "How can I book an Innova Crysta cab from Pune to Mumbai?",
        answer: "You can book by calling Meghana Cab at +91 9075462128 or through our website for quick and secure confirmation."
    },
    {
        question: "Is the Innova Crysta suitable for long-distance travel like Pune to Mumbai?",
        answer: "Yes, the Innova Crysta is a premium 6-7 seater SUV perfect for comfortable long-distance travel with ample luggage space."
    },
    {
        question: "What is the estimated travel time from Pune to Mumbai in an Innova Crysta?",
        answer: "The journey usually takes 3 to 4 hours depending on traffic conditions and pick-up location."
    },
    {
        question: "Is the Pune to Mumbai Innova Crysta service available 24/7?",
        answer: "Yes, we operate 24/7 to accommodate your travel needs at any hour."
    },
    {
        question: "What’s included in the Innova Crysta cab fare?",
        answer: "The fare includes fuel, toll charges, and driver fees. Extra waiting time or parking fees may be charged additionally."
    },
    {
        question: "Can I book the Innova Crysta for a one-way trip from Pune to Mumbai?",
        answer: "Yes, one-way as well as round-trip options are available for Innova Crysta bookings."
    },
    {
        question: "Is online booking available for Innova Crysta?",
        answer: "Absolutely. You can book online through our website 24/7 with secure payment options."
    },
    {
        question: "Are stops allowed during the Pune to Mumbai ride?",
        answer: "Yes, you can request breaks for meals or rest. Just inform the driver or mention it during booking."
    },
    {
        question: "Is the Innova Crysta air-conditioned and comfortable for family travel?",
        answer: "Yes, the Crysta is fully air-conditioned with reclining seats, ideal for family and group travel."
    },
    {
        question: "Are the drivers experienced for long routes like Pune to Mumbai?",
        answer: "Yes, all our drivers are trained, professional, and well-acquainted with the Pune to Mumbai route."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Suresh Naik',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The Innova Crysta was super comfortable for our group of six. Excellent service by Meghana Cab on our Pune to Mumbai trip.”',
    },
    {
        name: 'Ms. Anjali Pathak',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Very clean, well-maintained Crysta with a polite and professional driver. Best travel experience from Pune to Mumbai!”',
    },
];



























































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Innova Crysta Cab",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-mumbai-innova-crysta-cab.jpg",
  "description": "Book a comfortable and luxurious Innova Crysta cab from Pune to Mumbai with Meghana Cabs. Perfect for family and business travel, with AC and chauffeur-driven service available for one-way and round trips. Easy online booking 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5213"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-mumbai-innova-crysta-cab"
  }
};









    return (
        <div>

<Helmet>
  <title>Pune to Mumbai Innova Crysta Cab | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book Innova Crysta cab from Pune to Mumbai with Meghana Cabs. Comfortable 6-seater SUV with AC and chauffeur-driven service. Available for one-way and round trip travel. Book online 24/7." 
  />
  <meta 
    name="keywords" 
    content="Innova Crysta Cab Pune to Mumbai, Book Innova Crysta Pune to Mumbai, 6-Seater Crysta Pune to Mumbai Trip, AC Crysta Taxi Pune to Mumbai, Online Innova Crysta Booking Pune to Mumbai, Luxury SUV Cab Pune to Mumbai, Family Travel Innova Pune to Mumbai, Chauffeur Driven Innova Crysta Cab Pune to Mumbai, Round Trip Innova Crysta Pune to Mumbai, One Way Crysta Cab Pune to Mumbai, Comfortable Innova Pune to Mumbai Ride, Business Travel Cab Innova Crysta Pune to Mumbai, Budget Crysta Cab Hire Pune Mumbai, Group Travel Pune to Mumbai Innova Crysta, Safe Travel Crysta Cab Pune to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/64.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaiinnovacrystacab;